var map = {
	"./music-instructions.json": 4274,
	"./music-library-intro2024.json": 4275,
	"./music-library-launch2024.json": 4276,
	"./music-progression.json": 4277,
	"./startSourcesAdvanced.json": 4278,
	"./startSourcesSimple.json": 4279,
	"./startSourcesSimple2.json": 4280,
	"./startSourcesTracks.json": 4281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4026;